import { __extends } from "tslib";
import * as React from 'react';
var DENSITIES = [1, 2, 3];
var WixMedia = /** @class */ (function (_super) {
    __extends(WixMedia, _super);
    function WixMedia() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WixMedia.prototype.render = function () {
        var _a = this.props, hasFixedSize = _a.hasFixedSize, className = _a.className, alt = _a.alt, withSrcSet = _a.withSrcSet, width = _a.widthDimension, height = _a.heightDimension, onLoad = _a.onLoad, imgDataHook = _a.imgDataHook, ariaHidden = _a.ariaHidden;
        var style = hasFixedSize ? { width: width, height: height } : null;
        return (React.createElement("img", { onLoad: onLoad, className: className, "data-hook": imgDataHook || 'wix-media-image', src: this.getSrc(), srcSet: withSrcSet ? this.getSrcSet() : null, alt: alt, style: style, "aria-hidden": ariaHidden || false }));
    };
    WixMedia.prototype.getSrcSet = function () {
        var _a = this.props, mediaItem = _a.mediaItem, wixMediaFetcher = _a.wixMediaFetcher, width = _a.widthDimension, height = _a.heightDimension;
        return DENSITIES.map(function (density) {
            var url = wixMediaFetcher.getResizedImageUrl(mediaItem, { width: width * density, height: height * density });
            return url + " " + density + "x";
        }).join(', ');
    };
    WixMedia.prototype.getSrc = function () {
        var _a = this.props, mediaItem = _a.mediaItem, wixMediaFetcher = _a.wixMediaFetcher, width = _a.widthDimension, height = _a.heightDimension;
        return wixMediaFetcher.getResizedImageUrl(mediaItem, { width: width, height: height });
    };
    WixMedia.defaultProps = {
        hasFixedSize: true,
        withSrcSet: true,
    };
    return WixMedia;
}(React.PureComponent));
export { WixMedia };
//# sourceMappingURL=WixMedia.js.map